import { render } from "./SingleSelectDropdown.vue?vue&type=template&id=08dd89ac&scoped=true"
import script from "./SingleSelectDropdown.vue?vue&type=script&lang=js"
export * from "./SingleSelectDropdown.vue?vue&type=script&lang=js"

import "./SingleSelectDropdown.vue?vue&type=style&index=0&id=08dd89ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08dd89ac"]])

export default __exports__